import { GetterTree } from 'vuex';
import { ProfileState, RootState } from './profile-types';

export const getters: GetterTree<ProfileState, RootState> = {
  skillsEmployeeProfile: (state) => state.user?.body,
  skillsLevels: (state) => state.proficiency?.body.result,
  // skillsEmployeeProfile(state): string {
  //   const { user } = state;
  //   console.log('email', user);
  //   console.log('state', state);
  //   const email = (user && user.email) || 'saifi.razique@nile';
  //   console.log('email2', email);
  //   // const firstName = (user && user.firstName) || '';
  //   // const lastName = (user && user.lastName) || '';
  //   // return `${firstName} ${lastName}`;
  //   return email;
  // },
};
